import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const MenuIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 16 12"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M1.33334 1H14.6667M1.33334 6H14.6667M1.33334 11H7.16668"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(MenuIcon);
